import React, { Component } from 'react';
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import * as moment from "moment";
require("moment/locale/en-gb");
import { scrollBot } from '../utils/general';
// disable future dates
const today = moment();
const disableFutureDt = current => {
    return current.isBefore(today)
}

class DatePicker extends Component{
    openHandler = ()=>{
        // e.preventDefault();
        setTimeout(()=>{scrollBot()},200);
    }
    render(){
        return(
            <React.Fragment>
                <Datetime
                    locale="en-gb"
                    timeFormat={false}
                    isValidDate={disableFutureDt}
                    dateFormat="YYYY-MM-DD"
                    inputProps={{
                        placeholder: "Ex.YYYY-MM-DD",
                        readOnly: true
                    }}
                    onChange={(d)=>this.props.datePicAction(d)}
                    closeOnSelect={true}
                    closeOnClickOutside={true}
                    // open={true}
                    onOpen={this.openHandler}
                    className="is-datep"
                    readOnly={true}
                />
            </React.Fragment>
        )
    }
}
// DatePicker.propTypes = {
//     title: React.propTypes.node,
// }
export default DatePicker;